import React from 'react';
import Layout from '../components/Layout';
import FormBuilder from '../components/FormBuilder';

const FormBuilderPage = () => {
  return (
    <Layout>
      <FormBuilder />
    </Layout>
  );
};

export default FormBuilderPage;
